import { useMutation, useQueryClient } from '@tanstack/react-query';

import { redFlagsService } from '../services';

import { redFlagsKeys } from './useRedFlags';

interface CloseRedFlagInput {
  clientId: string;
  flagId: string;
  actionTaken: string;
}

/**
 * Closes a red flag. BE enforces chief-only via `red_flag:close`; the FE
 * caller is expected to gate the trigger UI on the same permission so the
 * button only appears for chiefs. Invalidates the BA-wide list, the
 * per-client list, and the open-flag count badge so every surface that
 * shows this flag refreshes.
 */
export function useCloseRedFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ clientId, flagId, actionTaken }: CloseRedFlagInput) =>
      redFlagsService.closeFlag({ clientId, flagId, actionTaken }),
    onSuccess: (_data, { clientId }) => {
      void qc.invalidateQueries({ queryKey: redFlagsKeys.lists() });
      void qc.invalidateQueries({ queryKey: redFlagsKeys.operation('client', { clientId }) });
      void qc.invalidateQueries({ queryKey: redFlagsKeys.operation('count-open') });
      void qc.invalidateQueries({ queryKey: redFlagsKeys.details() });
    },
  });
}
